import {FC} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import LinkButton from 'components/LinkButton';
import Panel from 'components/Panel';
import bizpayLogo from './bizpay_logo.png';

interface BizpayPanelProps {
    bizpayAffiliateUrl: string;
}

const BizpayPanel: FC<BizpayPanelProps> = ({bizpayAffiliateUrl}) => {
    const {t} = useTranslation('Portal');

    return (
        <Panel title={t('clientInboxItem.bizpayPanel.title')}>
            <div className="flex flex-col gap-y-2">
                <div>{t('clientInboxItem.bizpayPanel.description')}</div>
                <LinkButton
                    aria-label="pay"
                    className="w-full"
                    href={bizpayAffiliateUrl}
                    kind="secondary"
                    size="base"
                    target="_blank"
                >
                    <div className="flex items-center justify-center">
                        <Trans
                            className="block"
                            components={[
                                <img
                                    key="0"
                                    alt="bizpay"
                                    src={bizpayLogo}
                                    width="100px"
                                />,
                            ]}
                            i18nKey="clientInboxItem.bizpayPanel.linkText"
                            t={t}
                        />
                    </div>
                </LinkButton>
                <div className="text-grey-500 text-xs">
                    {t('clientInboxItem.bizpayPanel.disclaimer')}
                </div>
            </div>
        </Panel>
    );
};

export default BizpayPanel;
